export default __webpack_public_path__ + "static/sm-poster10-11ed76107058df1f9cadcd435aaea40e.png";